<div class="skz-select-wrapper" [class.compact]="compact()">
  <!-- ── Trigger ── -->
  <button
    #triggerBtn
    type="button"
    class="skz-select-trigger"
    [class.compact]="compact()"
    [class.is-open]="_disabled ? false : isOpen()"
    [class.is-disabled]="_disabled"
    [class.has-value]="hasValue"
    [attr.aria-haspopup]="'listbox'"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-disabled]="_disabled || null"
    [disabled]="_disabled || null"
    (click)="toggle()"
  >
    <span class="skz-select-trigger__value" [class.placeholder]="!hasValue">
      {{ hasValue ? (selectedLabel | translate) : placeholder() }}
    </span>

    <svg
      class="skz-select-trigger__chevron"
      [class.rotated]="isOpen()"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </button>

  <!-- ── Dropdown (position:fixed, escapes overflow:hidden parents) ── -->
  @if (isOpen()) {
    <ul
      class="skz-select-listbox"
      role="listbox"
      [style.top.px]="dropdownTop()"
      [style.bottom.px]="dropdownBottom()"
      [style.left.px]="dropdownLeft()"
      [style.min-width.px]="dropdownWidth()"
    >
      @for (option of options(); track option.value) {
        <li
          class="skz-select-option"
          role="option"
          [class.is-selected]="option.value === _value"
          [class.is-disabled]="option.disabled"
          [attr.aria-selected]="option.value === _value"
          [attr.aria-disabled]="option.disabled || null"
          (click)="select(option)"
        >
          <span class="skz-select-option__label">{{ option.label | translate }}</span>
          @if (option.value === _value) {
            <svg
              class="skz-select-option__check"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          }
        </li>
      }
    </ul>
  }
</div>
